import { INCOME_SOURCE_OPTIONS } from 'helpers/Constants';
import { mapDispatchButtonGroup } from 'reg_redesign/redux/connectFunctions';
import ButtonGroup from '@opploans/button-group-component/ButtonGroup';
import configureProgressBar from 'reg_redesign/config/configureProgressBar';
import configureTitle from 'reg_redesign/config/configureTitle';
import nextButtonConfig from 'reg_redesign/config/nextButtonConfig';

const page7 = {
  defaultNextPage: 'page-9',
  pageRule: [
    {
      logic: 'eval',
      targets: ['nextPage'],
      property: 'primaryIncomeSource',
      operator: 'equal',
      triggerValue: 'employment',
      resultValue: 'page-7.1'
    },
    {
      logic: 'eval',
      targets: ['nextPage'],
      property: 'primaryIncomeSource',
      operator: 'contain',
      triggerValue: ['other_taxable_income', 'other_non_taxable_income'],
      resultValue: 'page-7.1.2'
    }
  ],
  content: [
    configureProgressBar(30),
    configureTitle('What is your primary income source?'),
    {
      component: ButtonGroup,
      name: 'primaryIncomeSource',
      dispatchOverride: mapDispatchButtonGroup,
      props: {
        id: 'primaryIncomeSource',
        direction: 'column',
        options: INCOME_SOURCE_OPTIONS,
        alwaysShowSubtext: true
      }
    },
    nextButtonConfig('page-7')
  ]
};
export default page7;
